import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { FormFieldContainer, FormFieldInput } from "../../../react-components/modals/modal-form-elements";
import { InvestorTypes } from "../redux/profile/constants";
import { SetProfileStatePayload, SetProfileStateAction, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { AccountType } from "../../../redux/types/account-type";
import isEmpty from "lodash.isempty";

interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

interface MapStateProps {
  accountType: AccountType | null;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { setProfileState, accountType } = props;
  const [isOtherOption, setOtherOption] = React.useState(false);

  React.useEffect(() => {
    const isOtherOption = accountType !== null && !InvestorTypes.map((i) => i.title).includes(accountType?.subKind);
    setOtherOption(isOtherOption);
  }, [accountType, setProfileState]);

  return (
    <>
      <FormFieldContainer>
        <label htmlFor="investor-type">Select the type of investor you identify yourself with:*</label>
        <FormFieldInput>
          <select
            value={isOtherOption ? "Other" : accountType?.subKind ? accountType?.subKind : ""}
            onChange={(e) => {
              if (e.target.value === "Other") {
                setProfileState({ accountType: { ...accountType, subKind: "" } });
                setOtherOption(true);
              } else {
                setProfileState({ accountType: { ...accountType, subKind: e.target.value } });
                setOtherOption(false);
              }
            }}
          >
            <option disabled value={""}>
              Select investor type
            </option>
            {InvestorTypes.map((investor) => {
              return (
                <option key={`industry-${investor.title}`} value={investor.title}>
                  {investor.title}
                </option>
              );
            })}
            <option value={"Other"}>Other</option>
          </select>
        </FormFieldInput>
      </FormFieldContainer>
      {isOtherOption && (
        <FormFieldContainer>
          <label>Please specify other investor type:</label>
          <FormFieldInput>
            <textarea
              onChange={(e) => setProfileState({ accountType: { ...accountType, subKind: e.target.value } })}
              value={accountType?.subKind}
            />
          </FormFieldInput>
        </FormFieldContainer>
      )}
    </>
  );
};

const mapState = (state: AppState & ProfileModuleState) => ({
  accountType: state.profile.accountType,
});

const mapDispatch = {
  setProfileState: setProfileState,
};

export const InvestorType = connect(mapState, mapDispatch)(Component);
